/* eslint-disable import/no-cycle */
import { fork } from 'redux-saga/effects';

import { IS_ADMIN } from '@/services/Constants';
import rootAdminSaga from '@/admin/rootSaga';
import rootUserSaga from '@/rootSaga';

type Saga = (...args: any[]) => Generator;

export default function* rootSaga(): Generator {
	const sagas = (IS_ADMIN ? rootAdminSaga() : rootUserSaga()) as Saga[];

	for (const saga of sagas) {
		yield fork(saga);
	}
}
